// extracted by mini-css-extract-plugin
export default {"container":"zyK3n","agreement":"J5nHd","tariffCardStyle":"WceZq","heading":"Qb6RM","discountValue":"swqvu","discount":"nVLZU","discountLabel":"ll7LV","text":"AOcgR"};